import type { TaskStatus } from './types';
import { createStateTag } from 'components/StateTag';

export const TaskStatusTag = createStateTag<TaskStatus>({
  testId: 'task-status-tag',
  stateVariantMap: {
    PENDING: { icon: 'clock', variant: 'secondary' },
    ACTIVE: { icon: 'play', variant: 'warning' },
    DONE: { icon: 'circle-check', variant: 'success' },
    CANCELED: { icon: 'circle-xmark', variant: 'secondary' },
  },
});
